import { ReactNode, useEffect, useState } from 'react';

const DEFAULT_MS = 250;

export function DelayedBlock({ ms, children }: {
    ms?: number
    children?: ReactNode
}) {
    const [ show, setShow ] = useState(false);

    useEffect(() => {

        let timeoutId = setTimeout(() => {
            setShow(true);
        }, ms ?? DEFAULT_MS);
        return () => {
            clearTimeout(timeoutId);
        }

    });

    if(show) {
        return children;
    } else {
        return null;
    }
}